import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'onboarding.banner.gradient',
    defaultMessage: `{bannerType, select,
          Oxford {Tentez de gagner l’un des 1 000 cours en jeu ! Et plus encore... 🎁}
          Hachette {Votre premier cours d’essai est offert grâce à Objectif Bac ! ✌️}
          Maman {Vos frais pédagogiques sont offerts grâce à Maman jusqu’au bout des ongles ! ✌️}
          other {Votre premier cours d’essai est offert grâce à Vuibert ! ✌️}
        }`,
  },
});
